module.exports = __webpack_public_path__ + "assets/img/title-376f62f6.png";